import con from '../../../../../connection';
var path = '/upload';
var upload = function (url) { return function () { return ({
    post: function (param) {
        return con.post(url + path, param);
    },
}); }; };
export default upload;
